// import { Injectable } from "@angular/core";
// import { Socket } from "ngx-socket-io";
// import { Observable } from "rxjs";
// @Injectable({
//   providedIn: "root",
// })
// export class WebSocketService {
//   constructor(private socket: Socket) {
//     // this.connect()
//   }

//   connect() {
//     console.log(this.socket);
//     this.socket.on("connection", function () {
//       console.log("Connected");
//     });

//     this.socket.on("acceptPackage", function () {
//       console.log("connected");
//     });
//   }

//   // ✅ Emit location request properly with data
//   getNearbyDrivers(lat: number, lng: number, radiusKm: number): void {
//     this.socket.emit("getNearbyDrivers", { lat, lng, radiusKm });
//   }

//   // ✅ Listen for results
//   onNearbyDriversResult(): Observable<any> {
//     return this.socket.fromEvent("nearbyDriversResult");
//   }

//   onDriverLocation(): Observable<any> {
//     return this.socket.fromEvent("driverLocation");
//   }

//   onDriverLocationUpdate(): Observable<any> {
//     return this.socket.fromEvent("driverLocationUpdate");
//   }

//   onEnterpriseDriverLocationUpdate(): Observable<any> {
//     return this.socket.fromEvent("enterpriseDriverLocationUpdate");
//   }
//   // Optional: listen when admin connects successfully
//   onWelcome(): Observable<any> {
//     return this.socket.fromEvent("welcome");
//   }
// }



import { Injectable } from "@angular/core";
import { io, Socket } from "socket.io-client";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
@Injectable({
  providedIn: "root",
})
export class WebSocketService {
  private socket: Socket;

  constructor() {
    this.socket = io(environment.socketUrl, {
      transports: ["polling"],
      // add auth here if your adminNamespace ever gets an auth middleware, e.g.:
      // auth: { token: yourToken },
    });

    this.socket.on("connect", () => {
      console.log("Connected:", this.socket.id);
    });

    this.socket.on("connect_error", (err) => {
      console.error("connect_error:", err.message);
    });

    this.socket.on("acceptPackage", () => {
      console.log("acceptPackage received");
    });
  }

  // ✅ Emit location request properly with data
  getNearbyDrivers(lat: number, lng: number, radiusKm: number): void {
    this.socket.emit("getNearbyDrivers", { lat, lng, radiusKm });
  }

  // ✅ Listen for results
  onNearbyDriversResult(): Observable<any> {
    return new Observable((subscriber) => {
      this.socket.on("nearbyDriversResult", (data) => subscriber.next(data));
      return () => this.socket.off("nearbyDriversResult");
    });
  }

  onDriverLocation(): Observable<any> {
    return new Observable((subscriber) => {
      this.socket.on("driverLocation", (data) => subscriber.next(data));
      return () => this.socket.off("driverLocation");
    });
  }

  onDriverLocationUpdate(): Observable<any> {
    return new Observable((subscriber) => {
      this.socket.on("driverLocationUpdate", (data) => subscriber.next(data));
      return () => this.socket.off("driverLocationUpdate");
    });
  }

  onEnterpriseDriverLocationUpdate(): Observable<any> {
    return new Observable((subscriber) => {
      this.socket.on("enterpriseDriverLocationUpdate", (data) => subscriber.next(data));
      return () => this.socket.off("enterpriseDriverLocationUpdate");
    });
  }

  // Optional: listen when admin connects successfully
  onWelcome(): Observable<any> {
    return new Observable((subscriber) => {
      this.socket.on("welcome", (data) => subscriber.next(data));
      return () => this.socket.off("welcome");
    });
  }
}